export function useSiteSearch() {
  const open = useState('site-search-open', () => false)
  const query = useState('site-search-query', () => '')

  function openSearch(initial?: string) {
    if (typeof initial === 'string') query.value = initial
    open.value = true
  }

  function closeSearch() {
    open.value = false
  }

  return {
    open,
    query,
    openSearch,
    closeSearch,
  }
}
